
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexqzLSkVjElmKTfCG5lnw8ORKoJ64N8ScKRiOmHBlGnVMMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/index.vue?macro=true";
import { default as accountdxt9_dKimn_45oehG4nHjJ1KcbR3MirrAOMpqgxf2J88AMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/account-settings/common-layer/pages/account.vue?macro=true";
import { default as indexJkH29uF9rfeomF01Isn_4weXYVwbtW0HItjW_QbHaYwMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/auth/index.vue?macro=true";
import { default as logintIn6FfwU0nSrI0SBq0QesmFQ8JcrbbQOtnDTZl_Yw6sMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/auth/login.vue?macro=true";
import { default as signupyXkDCYRBo_45mm8U_45Of_tiPUmWxr7AVSK1D53pD__45Q54oMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/auth/signup.vue?macro=true";
import { default as _91_46_46_46notFound_93bi8RXw1pgtuqju3xp5WaOqV8_45tAC8MNuPYU0e3_45zis8Meta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/[...notFound].vue?macro=true";
import { default as indexNhtIZqD2NZ9gOXSJrQb_dSrQKe1FKvcBVj_QS2KxMHEMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/courses/index.vue?macro=true";
import { default as searchSx05u5kCKXsdiPQeANdj8Oz_45xCSbCuX4MHgk0xAUVd0Meta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/courses/routing-layer/pages/courses/search.vue?macro=true";
import { default as indexZQqsAxynhd_45xgjJF_45kO2a4Y30dpySUD1PgLaM5ueocMMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/invoices/index.vue?macro=true";
import { default as leadeZr97ay16zL_45XzuXNHY011nqxTFBUvBRvU8HIen3hMMMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/affiliates/lead.vue?macro=true";
import { default as indexQCJ9Liui9EhG4LvMqAY3qeg7KtGit8ORISYyySc8jyAMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/contracts/index.vue?macro=true";
import { default as indexdRu6v1vksldrqXboPZRCBo812Ar2_45uFDIdAmOqq1aKcMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/dashboard/index.vue?macro=true";
import { default as indexAnpthZhPSjjLPiVsgr4_lITJEjWVnrJJ1RVKI1dhHoIMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/documents/index.vue?macro=true";
import { default as index6jhVH_45Z8ziS0od0L7qrj6cKdVEtXKAdcy__457HdrUuGMMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/estimates/index.vue?macro=true";
import { default as indexFFuFboAb_453QOlOhhQb1ck05qo0CIXrL5vOdk_3_45qdT4Meta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/affiliates/index.vue?macro=true";
import { default as discoveru0LQKl_fdc415Lm76h139wn1flysAC6ahj0qufxUhM4Meta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/courses/discover.vue?macro=true";
import { default as bookkpuq7enjNHXjmKyaZYf_45V0u2p5gFiEIjDt__U99qSzEMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/appointments/book.vue?macro=true";
import { default as indexh6Ta8MSlfxUv1_4584bLW8kQCUslwLId9IugcIIZELYVoMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/communities/index.vue?macro=true";
import { default as indexNIc0Jxd_5X_G9bKCprWkyCG71LjepLEzdloYVNYWdA0Meta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/appointments/index.vue?macro=true";
import { default as my_45coursesWaKDKhnCj8vWH1NpfdOkIck7qARmrtEo4Z5spo2BQS4Meta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/courses/my-courses.vue?macro=true";
import { default as my_45library7zSqbQ_maKBvsNLYpSDepVIQtTZmRHufb9zJCuU4p9kMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/courses/routing-layer/pages/courses/my-library.vue?macro=true";
import { default as indexyEy_1JQ1Gx8eVO5Du7lVY3CYrsRUEdmD1on2zyesNA0Meta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/shared-files/index.vue?macro=true";
import { default as campaignmQkb3OWzPRhq8RHKtb5tW0Fhg31jr7vXmjsvlq3mGjsMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/affiliates/campaign.vue?macro=true";
import { default as reset_45passwordUxUfp_w8zLnuP2yrqkDYsc_0aYkiBHiyfIqPdiMn6pYMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/auth/reset-password.vue?macro=true";
import { default as _91productId_93VY0oc_pipnOANENCYjJaU20LH2sIs8LULn1l4mPotdYMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/courses/routing-layer/pages/courses/[productId].vue?macro=true";
import { default as forgot_45password6GH6DmxoovYh0ScsNO3QDWT_Nk8dVqivZc8aXvPIQ1kMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/auth/forgot-password.vue?macro=true";
import { default as login_45with_45codeazwB3HnDko2nnp6AJ1935ImSVUkSq4L9VZRglPDNRCQMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/auth/login-with-code.vue?macro=true";
import { default as discoverwEwEcth0LWFYpaZJSTFxqe4yjZDURH4E5x31QvofavUMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/communities/discover.vue?macro=true";
import { default as commissionkyxGig27g0w0I8pON8UmEl7uO5bvMdG_jVzbAFX6g2cMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/affiliates/commission.vue?macro=true";
import { default as expired_45password0KwP8mAHwshKdIgo4v_lQuGlU2C1FRHTtO6OT0X3b6IMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/auth/expired-password.vue?macro=true";
import { default as indexcTco1pNWvBj7UJyJNOKvrBReA5cYrXmOAGPXnMWQ_453wMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/affiliates/media/index.vue?macro=true";
import { default as sub_45affiliateKcVHUoMYI7_FTH9H9jjO9xhtOobFH3ajyJCjNWmAoAMMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/affiliates/sub-affiliate.vue?macro=true";
import { default as payout_45methodsnw1NWOM1dQOEVeYkJ0PTBq2IitPYYBu_GbtqgYyp9t4Meta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/affiliates/payout-methods.vue?macro=true";
import { default as profile_45confirmationqLLEVuf2nr7a8QKf2CSIdNAeip3xjqXf4_45N5ZDKvneYMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/auth/profile-confirmation.vue?macro=true";
import { default as my_45communitiesOkj2JT6NZbd826836rmssfdrQPIyw_sogjtPCrUlgmIMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/communities/my-communities.vue?macro=true";
import { default as not_45foundVLnsIAMUJ2TncI_6LNEHSqEdroKndLCghxfGmJdLqHIMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/not-found.vue?macro=true";
import { default as indexMVvVqrGNd6B_45NTr5y9YO439ysvfwMeAmvfdVvHHoQuEMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/conversations/index.vue?macro=true";
import { default as _91bundleOfferId_93wq8XBn6_454adJCTbxgM_rEkmysRgBlTGHZYUv_OgF_ykMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/courses/bundles/[bundleOfferId].vue?macro=true";
import { default as _91productId_93scT3LgjRo2SbjdiwYcMqCDRe77ePmqUJQZEQH2hg3QwMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/courses/routing-layer/pages/courses/products/new/[productId].vue?macro=true";
import { default as _91folderId_93Sm51r8oErh2MvJTgcHOiO7JMXbqRSgWSsByXXTR0INIMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/affiliates/media/folder/[folderId].vue?macro=true";
import { default as index01YLsHo7keF3JMKR6r_45q4LCnXi9AnAFIi4zgsFNMdqIMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/index.vue?macro=true";
import { default as indexvRmnXHyOxeDIN1GNdK0x5bC7u8zq6_truWlnN3BJxYEMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/courses/routing-layer/pages/courses/products/[productId]/index.vue?macro=true";
import { default as _91postId_93ez_Oqj7GqLaq1NDKt6mt9ZvNxOzH4UcK3nT6pMGP7O4Meta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/home/posts/[postId].vue?macro=true";
import { default as homePsjElc0vByqnkn_45jzCbZipMNqqiuxbcsAEKRAR_45YMs8Meta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/home.vue?macro=true";
import { default as aboutA_07Q_xTWWdb26sjVMx8Z7iv46j305tf8e_45MjzYL7ckMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/about.vue?macro=true";
import { default as indexEmIzKwid_8Eefm5FjdYRD_tcNWTOVW5HkJmc4u3Bd_4Meta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/index.vue?macro=true";
import { default as affiliatesIndexPage_46middlewareXjcyY3GbvQh8yFApvkyHkyo1mHFBRbmiOuGcegLYT6wMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/affiliates/affiliatesIndexPage.middleware.ts?macro=true";
import { default as communitiesMCWdA9uAMSisHfdWDK21TA1b54l7HxtXPcBr9TOP1mcMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/communities.vue?macro=true";
import { default as _91conversationId_9353cotexKG_45LQ9CW3juQniPuJa2adi9qEevZg_45JbeHMIMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/conversations/[conversationId].vue?macro=true";
import { default as leaderboardfwoyT_45Jwys9hPDkO9c3g4ZsH_45D5OAAhJgewpqG6X29AMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/leaderboard.vue?macro=true";
import { default as contributionsgUtJ8Qam93wUyar0zxf0baCcPUMNM8dIHBlJPxTlozEMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/contributions.vue?macro=true";
import { default as live_45sessionszXx8nqNCYF7gdDHMT002tOeaFsZocJfYzs8d6CuhFNMMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/courses/routing-layer/pages/courses/products/[productId]/live-sessions.vue?macro=true";
import { default as indexp_45RcNdRIVjnXZ913zXdIbBEUpEgTdUL64n9QE04tJaUMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/events/index.vue?macro=true";
import { default as _91postId_93IAKtl5_dhM1OsqBX9l4bqMa_wTTI0nDsjERiC8OZ4McMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/posts/[postId].vue?macro=true";
import { default as _91_46_46_46catchAll_935qA4WIcMcXIkxaS2ECVpWA9zRlLPSti9khH8M8jbyLYMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/[...catchAll].vue?macro=true";
import { default as conversationsOOg34fR5dzy7_45OsxhZeULYZERDJs35uy1WoFbZ4OY8QMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/conversations.vue?macro=true";
import { default as indexYEHy8GdFTpW_bKFbTfr0fhEKP0h4B2_Mx_c4FIK1BwMMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/members/index.vue?macro=true";
import { default as purchase_45course70oAnLvqyLAiC2N5NMlKDCWtivKMRuebO6TUt_5ZVK8Meta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/courses/routing-layer/pages/courses/products/[productId]/purchase-course.vue?macro=true";
import { default as indexuiAq0jIntiR59dQVhC0_45HJmZE6KnqMseoaJD0z5l_tQMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/learning/index.vue?macro=true";
import { default as indexsfdTAuBOyaEs8KUOcQSgXl4qHTUiDwPU9kOm8tgkiCwMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/index.vue?macro=true";
import { default as detailsR_4em8mm3mUcK1oSw0P_lon5p8nh9RGrLH81MfQzZNMMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/details.vue?macro=true";
import { default as branding8XhlandRB3boQj5wUauTqC3XiJpE40Mm7fnBD9FIoy4Meta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/branding.vue?macro=true";
import { default as discoverypr35SI2qnANE_ol6WDiQXrBPixc7RIr2LItPQwOVp0UMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/discovery.vue?macro=true";
import { default as content_45unavailable88_HQ1FoUA6mI9N7qnCljXEZMExgMByEJ5xkoPwplwsMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/content-unavailable.vue?macro=true";
import { default as appearance__45j6I9wP3YTecsbjnXn3fKihjjeib972ocaVCtIbNFkMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/appearance.vue?macro=true";
import { default as newsletterlFaUQ2Zm_459TWTW38M7L6lf2bZhuC9W9NvOOAQ04SLboMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/newsletter.vue?macro=true";
import { default as _91postId_934sIEp8aUUpbM3rnfIff3wdn0zblhEGx_3oplshKMgpEMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/channels/[channelSlug]/posts/[postId].vue?macro=true";
import { default as _91channelSlug_93sat5C9zW_XLZc7VbCSLC6A4opFqghJcW_QWPnJ45OV8Meta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/channels/[channelSlug].vue?macro=true";
import { default as subscriptionsebgS8WAXVYal8GeeAHuWVZ7TB0nMgBLSo_f7Rvi6Dt0Meta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/subscriptions.vue?macro=true";
import { default as community_45tabs4Jvf6EB3yCjYde5gNkSUInsKWf9wgSML6S45qPgN66gMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/community-tabs.vue?macro=true";
import { default as reported_45contenth5KrXHpGo0jg55qkE01QS1l6LJEGM6F54dcN82WhfrkMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/reported-content.vue?macro=true";
import { default as promotional_45linkse5Lp_45YSuBDUQFwxI58XG6Wu4c3gXbrkrVOEWEAhG5SIMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/promotional-links.vue?macro=true";
import { default as gamification_45rewardsPBmr5WOQs8SdPsRgVAuavt2bf_nurVowGJODKQIOZXoMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/gamification-rewards.vue?macro=true";
import { default as membership_45questionsJG4CKO89tE7f1rE_45DNw6uWqYwycFe_kpGx_D_45AE5jksMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/membership-questions.vue?macro=true";
import { default as _91lessonId_93fMDPv6d5ZTvDc0DViZbABtEEmyeQCQ0EicGDGN2zAOEMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/courses/routing-layer/pages/courses/products/[productId]/modules/[moduleId]/lessons/[lessonId].vue?macro=true";
import { default as _91lessonId_93U22WDLOiz8vwwQukjlVy7hocxyITMR_NpVz6q0SGzXoMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/courses/routing-layer/pages/courses/products/[productId]/modules/[moduleId]/lessons/new/[lessonId].vue?macro=true";
import { default as purchaseCKD_45QVZNrjxwsfXpUX9qRco9mtkO6lxII18p37uTF7kMeta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/learning/courses/products/[productId]/purchase.vue?macro=true";
import { default as _91lessonId_93h_45FjDf5PQWhLZVCsm4KjDX9mtoDs6wELe7h28TfOLJ4Meta } from "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/learning/courses/products/[productId]/modules/[moduleId]/lessons/[lessonId].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: {"cpRoute":true,"middleware":["redirect-clientportal-default-landing"]},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/index.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: { ...(accountdxt9_dKimn_45oehG4nHjJ1KcbR3MirrAOMpqgxf2J88AMeta || {}), ...{"middleware":[]} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/account-settings/common-layer/pages/account.vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: { ...(indexJkH29uF9rfeomF01Isn_4weXYVwbtW0HItjW_QbHaYwMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/auth/index.vue")
  },
  {
    name: "auth-login",
    path: "/login",
    meta: { ...(logintIn6FfwU0nSrI0SBq0QesmFQ8JcrbbQOtnDTZl_Yw6sMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/auth/login.vue")
  },
  {
    name: "auth-signup",
    path: "/signup",
    meta: { ...(signupyXkDCYRBo_45mm8U_45Of_tiPUmWxr7AVSK1D53pD__45Q54oMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/auth/signup.vue")
  },
  {
    name: "notFound",
    path: "/:notFound(.*)*",
    meta: {"cpRoute":true,"middleware":["redirect-clientportal-default-landing"]},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/[...notFound].vue")
  },
  {
    name: "courses",
    path: "/courses",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/courses/index.vue")
  },
  {
    name: "courses-search",
    path: "/courses/search",
    meta: searchSx05u5kCKXsdiPQeANdj8Oz_45xCSbCuX4MHgk0xAUVd0Meta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/courses/routing-layer/pages/courses/search.vue")
  },
  {
    name: "invoices",
    path: "/invoices",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/invoices/index.vue")
  },
  {
    name: "affiliates-lead",
    path: "/affiliates/lead",
    meta: { ...(leadeZr97ay16zL_45XzuXNHY011nqxTFBUvBRvU8HIen3hMMMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/affiliates/lead.vue")
  },
  {
    name: "contracts",
    path: "/contracts",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/contracts/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/dashboard/index.vue")
  },
  {
    name: "documents",
    path: "/documents",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/documents/index.vue")
  },
  {
    name: "estimates",
    path: "/estimates",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/estimates/index.vue")
  },
  {
    name: "affiliates",
    path: "/affiliates",
    meta: { ...(indexFFuFboAb_453QOlOhhQb1ck05qo0CIXrL5vOdk_3_45qdT4Meta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/affiliates/index.vue")
  },
  {
    name: "courses-discover",
    path: "/courses/discover",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/courses/discover.vue")
  },
  {
    name: "appointments-book",
    path: "/appointments/book",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/appointments/book.vue")
  },
  {
    name: "communities",
    path: "/communities",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/communities/index.vue")
  },
  {
    name: "appointments",
    path: "/appointments",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/appointments/index.vue")
  },
  {
    name: "courses-my-courses",
    path: "/courses/my-courses",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/courses/my-courses.vue")
  },
  {
    name: "courses-my-library",
    path: "/courses/my-library",
    meta: my_45library7zSqbQ_maKBvsNLYpSDepVIQtTZmRHufb9zJCuU4p9kMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/courses/routing-layer/pages/courses/my-library.vue")
  },
  {
    name: "shared-files",
    path: "/shared-files",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/shared-files/index.vue")
  },
  {
    name: "affiliates-campaign",
    path: "/affiliates/campaign",
    meta: { ...(campaignmQkb3OWzPRhq8RHKtb5tW0Fhg31jr7vXmjsvlq3mGjsMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/affiliates/campaign.vue")
  },
  {
    name: "auth-reset-password",
    path: "/reset-password",
    meta: { ...(reset_45passwordUxUfp_w8zLnuP2yrqkDYsc_0aYkiBHiyfIqPdiMn6pYMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/auth/reset-password.vue")
  },
  {
    name: "courses-checkout",
    path: "/courses/:productId()",
    meta: _91productId_93VY0oc_pipnOANENCYjJaU20LH2sIs8LULn1l4mPotdYMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/courses/routing-layer/pages/courses/[productId].vue")
  },
  {
    name: "auth-forgot-password",
    path: "/forgot-password",
    meta: { ...(forgot_45password6GH6DmxoovYh0ScsNO3QDWT_Nk8dVqivZc8aXvPIQ1kMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-login-with-code",
    path: "/login-with-code",
    meta: { ...(login_45with_45codeazwB3HnDko2nnp6AJ1935ImSVUkSq4L9VZRglPDNRCQMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/auth/login-with-code.vue")
  },
  {
    name: "communities-discover",
    path: "/communities/discover",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/communities/discover.vue")
  },
  {
    name: "affiliates-commission",
    path: "/affiliates/commission",
    meta: { ...(commissionkyxGig27g0w0I8pON8UmEl7uO5bvMdG_jVzbAFX6g2cMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/affiliates/commission.vue")
  },
  {
    name: "auth-expired-password",
    path: "/expired-password",
    meta: { ...(expired_45password0KwP8mAHwshKdIgo4v_lQuGlU2C1FRHTtO6OT0X3b6IMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/auth/expired-password.vue")
  },
  {
    name: "affiliates-media",
    path: "/affiliates/media",
    meta: { ...(indexcTco1pNWvBj7UJyJNOKvrBReA5cYrXmOAGPXnMWQ_453wMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/affiliates/media/index.vue")
  },
  {
    name: "affiliates-sub-affiliate",
    path: "/affiliates/sub-affiliate",
    meta: { ...(sub_45affiliateKcVHUoMYI7_FTH9H9jjO9xhtOobFH3ajyJCjNWmAoAMMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/affiliates/sub-affiliate.vue")
  },
  {
    name: "affiliates-payout-methods",
    path: "/affiliates/payout-methods",
    meta: { ...(payout_45methodsnw1NWOM1dQOEVeYkJ0PTBq2IitPYYBu_GbtqgYyp9t4Meta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/affiliates/payout-methods.vue")
  },
  {
    name: "auth-profile-confirmation",
    path: "/profile-confirmation",
    meta: { ...(profile_45confirmationqLLEVuf2nr7a8QKf2CSIdNAeip3xjqXf4_45N5ZDKvneYMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/auth/profile-confirmation.vue")
  },
  {
    name: "communities-my-communities",
    path: "/communities/my-communities",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/communities/my-communities.vue")
  },
  {
    name: "communities-groups-not-found",
    path: "/communities/groups/not-found",
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/not-found.vue")
  },
  {
    name: "communities-conversations",
    path: "/communities/conversations",
    meta: indexMVvVqrGNd6B_45NTr5y9YO439ysvfwMeAmvfdVvHHoQuEMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/conversations/index.vue")
  },
  {
    name: "courses-bundles-bundleOfferId",
    path: "/courses/bundles/:bundleOfferId()",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/courses/bundles/[bundleOfferId].vue")
  },
  {
    name: "courses-products-new-productId",
    path: "/courses/products/new/:productId()",
    meta: _91productId_93scT3LgjRo2SbjdiwYcMqCDRe77ePmqUJQZEQH2hg3QwMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/courses/routing-layer/pages/courses/products/new/[productId].vue")
  },
  {
    name: "affiliates-media-folder-folderId",
    path: "/affiliates/media/folder/:folderId()",
    meta: { ...(_91folderId_93Sm51r8oErh2MvJTgcHOiO7JMXbqRSgWSsByXXTR0INIMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/affiliates/media/folder/[folderId].vue")
  },
  {
    name: "communities-users-userSlug",
    path: "/communities/users/:userSlug()",
    meta: index01YLsHo7keF3JMKR6r_45q4LCnXi9AnAFIi4zgsFNMdqIMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/index.vue")
  },
  {
    name: "courses-products-productId",
    path: "/courses/products/:productId()",
    meta: indexvRmnXHyOxeDIN1GNdK0x5bC7u8zq6_truWlnN3BJxYEMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/courses/routing-layer/pages/courses/products/[productId]/index.vue")
  },
  {
    name: "communities-groups-groupSlug-home",
    path: "/communities/groups/:groupSlug()/home",
    meta: homePsjElc0vByqnkn_45jzCbZipMNqqiuxbcsAEKRAR_45YMs8Meta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/home.vue"),
    children: [
  {
    name: "communities-groups-groupSlug-home-posts-postId",
    path: "posts/:postId()",
    meta: _91postId_93ez_Oqj7GqLaq1NDKt6mt9ZvNxOzH4UcK3nT6pMGP7O4Meta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/home/posts/[postId].vue")
  }
]
  },
  {
    name: "communities-groups-groupSlug-about",
    path: "/communities/groups/:groupSlug()/about",
    meta: aboutA_07Q_xTWWdb26sjVMx8Z7iv46j305tf8e_45MjzYL7ckMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/about.vue")
  },
  {
    name: "communities-groups-groupSlug",
    path: "/communities/groups/:groupSlug()",
    meta: indexEmIzKwid_8Eefm5FjdYRD_tcNWTOVW5HkJmc4u3Bd_4Meta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/index.vue")
  },
  {
    name: "affiliates-affiliatesIndexPage.middleware",
    path: "/affiliates/affiliatesIndexPage.middleware",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/clientportal/routing-layer/pages/affiliates/affiliatesIndexPage.middleware.ts")
  },
  {
    name: "communities-users-userSlug-communities",
    path: "/communities/users/:userSlug()/communities",
    meta: communitiesMCWdA9uAMSisHfdWDK21TA1b54l7HxtXPcBr9TOP1mcMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/communities.vue")
  },
  {
    name: "communities-conversations-conversationId",
    path: "/communities/conversations/:conversationId()",
    meta: _91conversationId_9353cotexKG_45LQ9CW3juQniPuJa2adi9qEevZg_45JbeHMIMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/conversations/[conversationId].vue")
  },
  {
    name: "communities-groups-groupSlug-leaderboard",
    path: "/communities/groups/:groupSlug()/leaderboard",
    meta: leaderboardfwoyT_45Jwys9hPDkO9c3g4ZsH_45D5OAAhJgewpqG6X29AMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/leaderboard.vue")
  },
  {
    name: "communities-users-userSlug-contributions",
    path: "/communities/users/:userSlug()/contributions",
    meta: contributionsgUtJ8Qam93wUyar0zxf0baCcPUMNM8dIHBlJPxTlozEMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/contributions.vue")
  },
  {
    name: "courses-products-productId-live-sessions",
    path: "/courses/products/:productId()/live-sessions",
    meta: live_45sessionszXx8nqNCYF7gdDHMT002tOeaFsZocJfYzs8d6CuhFNMMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/courses/routing-layer/pages/courses/products/[productId]/live-sessions.vue")
  },
  {
    name: "communities-groups-groupSlug-events",
    path: "/communities/groups/:groupSlug()/events",
    meta: indexp_45RcNdRIVjnXZ913zXdIbBEUpEgTdUL64n9QE04tJaUMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/events/index.vue")
  },
  {
    name: "communities-users-userSlug-posts-postId",
    path: "/communities/users/:userSlug()/posts/:postId()",
    meta: _91postId_93IAKtl5_dhM1OsqBX9l4bqMa_wTTI0nDsjERiC8OZ4McMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/posts/[postId].vue")
  },
  {
    name: "communities-groups-groupSlug-catchAll",
    path: "/communities/groups/:groupSlug()/:catchAll(.*)*",
    meta: _91_46_46_46catchAll_935qA4WIcMcXIkxaS2ECVpWA9zRlLPSti9khH8M8jbyLYMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/[...catchAll].vue")
  },
  {
    name: "communities-groups-groupSlug-conversations",
    path: "/communities/groups/:groupSlug()/conversations",
    meta: conversationsOOg34fR5dzy7_45OsxhZeULYZERDJs35uy1WoFbZ4OY8QMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/conversations.vue")
  },
  {
    name: "communities-groups-groupSlug-members",
    path: "/communities/groups/:groupSlug()/members",
    meta: indexYEHy8GdFTpW_bKFbTfr0fhEKP0h4B2_Mx_c4FIK1BwMMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/members/index.vue")
  },
  {
    name: "courses-products-productId-purchase-course",
    path: "/courses/products/:productId()/purchase-course",
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/courses/routing-layer/pages/courses/products/[productId]/purchase-course.vue")
  },
  {
    name: "communities-groups-groupSlug-learning",
    path: "/communities/groups/:groupSlug()/learning",
    meta: indexuiAq0jIntiR59dQVhC0_45HJmZE6KnqMseoaJD0z5l_tQMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/learning/index.vue")
  },
  {
    name: "communities-groups-groupSlug-settings",
    path: "/communities/groups/:groupSlug()/settings",
    meta: indexsfdTAuBOyaEs8KUOcQSgXl4qHTUiDwPU9kOm8tgkiCwMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/index.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-details",
    path: "/communities/groups/:groupSlug()/settings/details",
    meta: detailsR_4em8mm3mUcK1oSw0P_lon5p8nh9RGrLH81MfQzZNMMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/details.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-branding",
    path: "/communities/groups/:groupSlug()/settings/branding",
    meta: branding8XhlandRB3boQj5wUauTqC3XiJpE40Mm7fnBD9FIoy4Meta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/branding.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-discovery",
    path: "/communities/groups/:groupSlug()/settings/discovery",
    meta: discoverypr35SI2qnANE_ol6WDiQXrBPixc7RIr2LItPQwOVp0UMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/discovery.vue")
  },
  {
    name: "communities-groups-groupSlug-content-unavailable",
    path: "/communities/groups/:groupSlug()/content-unavailable",
    meta: content_45unavailable88_HQ1FoUA6mI9N7qnCljXEZMExgMByEJ5xkoPwplwsMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/content-unavailable.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-appearance",
    path: "/communities/groups/:groupSlug()/settings/appearance",
    meta: appearance__45j6I9wP3YTecsbjnXn3fKihjjeib972ocaVCtIbNFkMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/appearance.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-newsletter",
    path: "/communities/groups/:groupSlug()/settings/newsletter",
    meta: newsletterlFaUQ2Zm_459TWTW38M7L6lf2bZhuC9W9NvOOAQ04SLboMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/newsletter.vue")
  },
  {
    name: "communities-groups-groupSlug-channels-channelSlug",
    path: "/communities/groups/:groupSlug()/channels/:channelSlug()",
    meta: _91channelSlug_93sat5C9zW_XLZc7VbCSLC6A4opFqghJcW_QWPnJ45OV8Meta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/channels/[channelSlug].vue"),
    children: [
  {
    name: "communities-groups-groupSlug-channels-channelSlug-posts-postId",
    path: "posts/:postId()",
    meta: _91postId_934sIEp8aUUpbM3rnfIff3wdn0zblhEGx_3oplshKMgpEMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/channels/[channelSlug]/posts/[postId].vue")
  }
]
  },
  {
    name: "communities-groups-groupSlug-settings-subscriptions",
    path: "/communities/groups/:groupSlug()/settings/subscriptions",
    meta: subscriptionsebgS8WAXVYal8GeeAHuWVZ7TB0nMgBLSo_f7Rvi6Dt0Meta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/subscriptions.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-community-tabs",
    path: "/communities/groups/:groupSlug()/settings/community-tabs",
    meta: community_45tabs4Jvf6EB3yCjYde5gNkSUInsKWf9wgSML6S45qPgN66gMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/community-tabs.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-reported-content",
    path: "/communities/groups/:groupSlug()/settings/reported-content",
    meta: reported_45contenth5KrXHpGo0jg55qkE01QS1l6LJEGM6F54dcN82WhfrkMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/reported-content.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-promotional-links",
    path: "/communities/groups/:groupSlug()/settings/promotional-links",
    meta: promotional_45linkse5Lp_45YSuBDUQFwxI58XG6Wu4c3gXbrkrVOEWEAhG5SIMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/promotional-links.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-gamification-rewards",
    path: "/communities/groups/:groupSlug()/settings/gamification-rewards",
    meta: gamification_45rewardsPBmr5WOQs8SdPsRgVAuavt2bf_nurVowGJODKQIOZXoMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/gamification-rewards.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-membership-questions",
    path: "/communities/groups/:groupSlug()/settings/membership-questions",
    meta: membership_45questionsJG4CKO89tE7f1rE_45DNw6uWqYwycFe_kpGx_D_45AE5jksMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/membership-questions.vue")
  },
  {
    name: "courses-products-productId-modules-moduleId-lessons-lessonId",
    path: "/courses/products/:productId()/modules/:moduleId()/lessons/:lessonId()",
    meta: _91lessonId_93fMDPv6d5ZTvDc0DViZbABtEEmyeQCQ0EicGDGN2zAOEMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/courses/routing-layer/pages/courses/products/[productId]/modules/[moduleId]/lessons/[lessonId].vue")
  },
  {
    name: "courses-products-productId-modules-moduleId-lessons-new-lessonId",
    path: "/courses/products/:productId()/modules/:moduleId()/lessons/new/:lessonId()",
    meta: _91lessonId_93U22WDLOiz8vwwQukjlVy7hocxyITMR_NpVz6q0SGzXoMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/courses/routing-layer/pages/courses/products/[productId]/modules/[moduleId]/lessons/new/[lessonId].vue")
  },
  {
    name: "courses-purchase-product",
    path: "/communities/groups/:groupSlug()/learning/courses/products/:productId()/purchase",
    meta: purchaseCKD_45QVZNrjxwsfXpUX9qRco9mtkO6lxII18p37uTF7kMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/learning/courses/products/[productId]/purchase.vue")
  },
  {
    name: "communities-groups-groupSlug-learning-courses-products-productId-modules-moduleId-lessons-lessonId",
    path: "/communities/groups/:groupSlug()/learning/courses/products/:productId()/modules/:moduleId()/lessons/:lessonId()",
    meta: _91lessonId_93h_45FjDf5PQWhLZVCsm4KjDX9mtoDs6wELe7h28TfOLJ4Meta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/learning/courses/products/[productId]/modules/[moduleId]/lessons/[lessonId].vue")
  }
]